import React from "react";
import { CompanyCardVoucherContainer } from "./CompanyCardVoucherStyled";

import avatar from './../../utils/images/avatar_fluincr.png';
import { toUpperCase } from "../../services/generalSevices";
import { useNavigate } from 'react-router-dom';


export default function CompanyCardVoucher({ company, page }) {

    const navigate = useNavigate();

    return (
        <CompanyCardVoucherContainer page={page} >

            <div className="image" style={{ backgroundImage: `url(${(company.imageprofile !== null) ? company.imageprofile : avatar})` }} >
            </div>

            <h3 className="name" onClick={() => {
                navigate(`/${company.username}`)
            }}>{(toUpperCase({ fullName: company.namecompany }))}</h3>

            <div className="companyData">
                <img src={company?.imagecountry} alt="" className="companyCountry" />
                <div className="categories">
                    {company?.namecategory?.map((category, index) => {
                        if (index < 2) {
                            return (
                                <span className="category">#{category}</span>
                            )
                        }

                    })}
                </div>
            </div>
        </CompanyCardVoucherContainer>
    )
}